import { format } from 'date-fns';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import SmartLink from '../Common/SmartLink';
import * as styles from './BlogCard.module.css';

const BlogCard = (props) => {
  const { img, gatsbyImageData, readTime, title, description, author, date, isSmall, slug, category } = props;
  const postDate = format(new Date(date), 'MMMM dd, yyyy');
  let image = <img loading="lazy" alt={title} src={img} />;
  if (gatsbyImageData) {
    image = <GatsbyImage loading="lazy" image={gatsbyImageData} alt={title} />;
  }
  return (
    <div>
      <SmartLink className={isSmall ? styles.cardSmall : styles.card} to={`/blog/${slug}`}>
        {image}
        <div>
          {!isSmall && (
            <span>
              {category}
              {category && ' · '}
              {readTime || '1 min read'}
            </span>
          )}
          <h3>{title}</h3>
          <p>{description}</p>
          {!isSmall && (
            <span>
              {author} on {postDate}
            </span>
          )}
        </div>
      </SmartLink>
    </div>
  );
};

BlogCard.defaultProps = {
  isSmall: false,
};

BlogCard.propTypes = {
  img: PropTypes.object,
  gatsbyImageData: PropTypes.object,
  readTime: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  author: PropTypes.string,
  date: PropTypes.string,
  isSmall: PropTypes.bool,
};

export default BlogCard;
